module.exports = __webpack_public_path__ + "img/vk.6b71b0ac.svg";